import React from 'react';
import { Link } from 'react-router-dom';
import FadeIn from '../common/FadeIn';

const termsData = [
  {
    id: 1,
    title: "1. Introduction",
    content: "Welcome to SeaSalt Creative. By using this website or booking our services, you agree to these Terms & Conditions."
  },
  {
    id: 2,
    title: "2. Our Services",
    content: "SeaSalt Creative provides website customization and development services. You can choose a design and have it customized with your content, images, logo, colors, contact details, and other approved information."
  },
  {
    id: 3,
    title: "3. Your Responsibilities",
    content: "Please provide the required text, images, logo, business details, and other content on time. You are responsible for making sure the information you provide is accurate and that you have permission to use any content you send us."
  },
  {
    id: 4,
    title: "4. Website Review",
    content: "You will receive a website preview before it goes live. Please check the content, images, links, and other details carefully and let us know about any changes before giving final approval."
  },
  {
    id: 5,
    title: "5. Domain & Hosting",
    content: "If domain or hosting setup is included in your package, we can help with the setup. You are responsible for your domain and hosting accounts, including renewals and payments."
  },
  {
    id: 6,
    title: "6. Timeline",
    content: "The project timeline depends on receiving your content, feedback, and approvals on time. Delays in these areas may also delay the website launch."
  },
  {
    id: 7,
    title: "7. Changes",
    content: "We may update these Terms & Conditions when needed. Any changes will be posted on this page."
  },
  {
    id: 8,
    title: "8. Contact",
    isContact: true,
    content: "If you have any questions about these Terms & Conditions or our services, please contact SeaSalt Creative through our Contact page."
  }
];

const TermsContentSection = () => {
  return (
    <section className="w-full bg-[#f9f9f5] py-12 sm:py-16 md:py-20 px-6 sm:px-10 md:px-16 text-[#1C1917]">
      <div className="max-w-[920px] mx-auto space-y-10 sm:space-y-12">
        {termsData.map((item) => (
          <FadeIn key={item.id}>
            <div>
              <h2 className="font-saolDisplayItalic font-semibold leading-[1.2] text-[24px] md:text-[32px] mb-3 md:mb-4">
                {item.title}
              </h2>

              {item.content && (
                <p className="font-inter-display-medium text-[15px] text-justify font-medium tracking-[0.01em] leading-[1.8]">
                  {item.content}
                </p>
              )}

              {item.intro && (
                <p className="font-inter-display-medium text-[15px] text-justify font-medium tracking-[0.01em] leading-[1.8] mb-3">
                  {item.intro}
                  {item.isContact && (
                    <>
                      <Link to="/inquiry" className="text-[#ce884d] underline hover:text-[#1C1917] transition-colors">
                        Contact page
                      </Link>{' '}
                      or using the contact information available on our website.
                    </>
                  )}
                </p>
              )}

              {item.list && (
                <ul className="list-disc pl-6 space-y-1.5 font-inter-display-medium text-[15px] font-medium tracking-[0.01em] leading-[1.8] text-[#1C1917] mb-3">
                  {item.list.map((bullet, idx) => (
                    <li key={idx}>{bullet}</li>
                  ))}
                </ul>
              )}

              {item.outro && (
                <p className="font-inter-display-medium text-[15px] text-justify font-medium tracking-[0.01em] leading-[1.8]">
                  {item.outro}
                </p>
              )}
            </div>
          </FadeIn>
        ))}
      </div>
    </section>
  );
};

export default TermsContentSection;
